export const USER_ORDER_MEMO_UPDATE = 'USER_ORDER_MEMO_UPDATE';
